export const customColors = {
  primary: {
    100: "#CCE4D9",
    200: "#A2D2BD",
    300: "#7DB798",
    400: "#579B72",
    // based on #0B6327
    50: "#E1EDE7",
    500: "#317F4D",
    600: "#0B6327",
    700: "#0B5028",
    800: "#0B3C29",
    900: "#061E15",
  },
  primaryVariant: {
    // based on #0B6327 (but shifted towards white)
    // required because native base defaults to 800
    600: "#E1EDE7",
    700: "#CCE4D9",
    800: "#A2D2BD",
    900: "#7DB798",
  },
  // rarely used - only when another colour is needed to differentiate
  secondary: {
    100: "#E5EDF0",
    200: "#C1E6F7",
    300: "#B2E0F5",
    400: "#A2D9F3",
    // based on #0599DC
    50: "#F0F9FD",
    500: "#82CCEE",
    600: "#0599DC",
    700: "#0473A5",
    800: "#034D6E",
    900: "#022737",
  },
  surface: {
    100: "#F1F1F1",
    200: "#DBDBDB",
    300: "#D0D0D0",
    400: "#C4C4C4",
    // based on #A3A3A3
    50: "#F5F5F5",
    500: "#B4B4B4",
    600: "#A3A3A3",
    700: "#7B7B7B",
    800: "#525252",
    900: "#3D3C3C",
  },
};

// this theme is used by Native Base (main component library)
const themeExtensions = {
  // colour shades created using Coolors
  colors: customColors,
  components: {
    AlertDialog: {
      defaultProps: {
        _backdrop: {
          _hover: { opacity: 0.3 },
          _pressed: { opacity: 0.3 },
        },
      },
    },
    AlertDialogCloseButton: {
      defaultProps: {
        borderRadius: "xl",
      },
    },
    AlertDialogContent: {
      defaultProps: {
        bg: "surface.100",
        borderRadius: "2xl",
      },
    },
    AlertDialogFooter: {
      defaultProps: {
        borderTopWidth: 0,
      },
    },
    AlertDialogHeader: {
      defaultProps: {
        _text: { fontSize: "xl", mx: 2 },
        borderBottomWidth: 0,
      },
    },
    Button: {
      defaultProps: {
        _loading: { opacity: 1 },
        _text: {
          allowFontScaling: false,
          fontFamily: "Poppins-SemiBold",
          fontSize: "md",
          textAlign: "center",
        },
        borderRadius: "2xl",
      },
    },
    Checkbox: {
      defaultProps: {
        bg: "surface.100",
        borderColor: "surface.200",
      },
    },
    Divider: {
      defaultProps: {
        bg: "surface.700",
        borderRadius: "full",
        height: "50%",
        orientation: "vertical",
      },
    },
    Heading: {
      defaultProps: {
        allowFontScaling: false,
        color: "surface.900",
        fontSize: "lg",
      },
    },
    HStack: {
      defaultProps: {
        alignItems: "center",
      },
    },
    Input: {
      defaultProps: {
        allowFontScaling: false,
        borderRadius: "20",
        selectionColor: "primary.300",
      },
    },
    Modal: {
      defaultProps: {
        _backdrop: {
          _hover: { opacity: 0.3 },
          _pressed: { opacity: 0.3 },
        },
      },
    },
    ModalCloseButton: {
      defaultProps: {
        borderRadius: "2xl",
        mr: "-1",
        p: "2.5",
      },
    },
    ModalContent: {
      defaultProps: {
        bg: "surface.50",
        borderRadius: "2xl",
      },
    },
    ModalFooter: {
      defaultProps: {
        borderTopWidth: 0,
      },
    },
    ModalHeader: {
      defaultProps: {
        _text: { fontSize: "xl", mx: "8", textAlign: "center" },
        bg: "surface.50",
        borderBottomWidth: 0,
      },
    },
    Pressable: {
      defaultProps: {
        _hover: { opacity: 0.7 },
        _pressed: { opacity: 0.6 },
      },
    },
    Text: {
      defaultProps: {
        allowFontScaling: false,
        color: "surface.900",
        includeFontPadding: false,
      },
    },
    Tooltip: {
      defaultProps: {
        borderRadius: "xl",
      },
    },
  },
  config: {
    initialColorMode: "light",
  },
  fontConfig: {
    Poppins: {
      // https://fonts.google.com/specimen/Poppins
      200: {
        italic: "Poppins-LightItalic",
        normal: "Poppins-Light",
      },
      300: {
        italic: "Poppins-Italic",
        normal: "Poppins-Regular",
      },
      400: {
        italic: "Poppins-SemiBoldItalic",
        normal: "Poppins-SemiBold",
      },
      600: {
        italic: "Poppins-SemiBoldItalic",
        normal: "Poppins-SemiBold",
      },
      700: {
        italic: "Poppins-BoldItalic",
        normal: "Poppins-Bold",
      },
      800: {
        italic: "Poppins-ExtraBoldItalic",
        normal: "Poppins-ExtraBold",
      },
      900: {
        italic: "Poppins-BlackItalic",
        normal: "Poppins-Black",
      },
    },
  },
  fonts: {
    body: "Poppins",
    heading: "Poppins",
    mono: "Poppins",
  },
};

export default themeExtensions;
